export default "__VITE_ASSET__BzD6VFXG__"